import React, { useCallback, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { CloudUploadOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DropzoneContainer = styled.button.withConfig({
  displayName: "file-dropzonecomponent__DropzoneContainer",
  componentId: "sc-rahgqw-0"
})(["width:100%;border:1.5px dashed #e0e4ef;border-radius:12px;padding:24px;background-color:#f8fafc;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;cursor:pointer;transition:border-color 0.2s ease,background-color 0.2s ease,box-shadow 0.2s ease;&:hover{border-color:#5a6acf;background-color:#f1f5f9;box-shadow:0 8px 16px rgba(15,23,42,0.06);}&:disabled{cursor:not-allowed;opacity:0.7;}"]);
var IconCircle = styled.div.withConfig({
  displayName: "file-dropzonecomponent__IconCircle",
  componentId: "sc-rahgqw-1"
})(["width:56px;height:56px;border-radius:999px;background:#ffffff;display:flex;align-items:center;justify-content:center;box-shadow:0 10px 25px rgba(37,99,235,0.16);color:#2563eb;"]);
var Title = styled.div.withConfig({
  displayName: "file-dropzonecomponent__Title",
  componentId: "sc-rahgqw-2"
})(["font-size:15px;color:#1a2140;text-align:center;"]);
var BrowseText = styled.span.withConfig({
  displayName: "file-dropzonecomponent__BrowseText",
  componentId: "sc-rahgqw-3"
})(["color:#2563eb;font-weight:600;text-decoration:underline;"]);
var HelperText = styled.div.withConfig({
  displayName: "file-dropzonecomponent__HelperText",
  componentId: "sc-rahgqw-4"
})(["font-size:12px;color:#8b95b0;text-align:center;"]);
export var FileDropzone = function FileDropzone(_ref) {
  var onFilesSelected = _ref.onFilesSelected,
      disabled = _ref.disabled,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      accept = _ref.accept;
  var inputRef = useRef(null);
  var handleFiles = useCallback(function (files) {
    if (!files || disabled) return;
    onFilesSelected(Array.from(files));
  }, [disabled, onFilesSelected]);
  var handleClick = useCallback(function () {
    var _inputRef$current;

    if (disabled) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  }, [disabled]);
  var handleChange = useCallback(function (event) {
    handleFiles(event.target.files); // allow same file to be re-selected

    event.target.value = '';
  }, [handleFiles]);
  var handleDragOver = useCallback(function (event) {
    if (disabled) return;
    event.preventDefault();
    event.stopPropagation();
  }, [disabled]);
  var handleDrop = useCallback(function (event) {
    if (disabled) return;
    event.preventDefault();
    event.stopPropagation();
    var files = event.dataTransfer.files;
    handleFiles(files);
  }, [disabled, handleFiles]);
  var formattedAcceptFileExtension = useMemo(function () {
    if (!(accept !== null && accept !== void 0 && accept.length)) return 'ALL';
    return accept.map(function (ext) {
      return ext.replace(/\./g, '').toUpperCase();
    }).join(', ');
  }, [accept]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DropzoneContainer, {
      type: "button",
      onClick: handleClick,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(IconCircle, {
        children: /*#__PURE__*/_jsx(CloudUploadOutlined, {
          style: {
            fontSize: 24
          }
        })
      }), /*#__PURE__*/_jsxs(Title, {
        children: ["Drag & drop files here or ", /*#__PURE__*/_jsx(BrowseText, {
          children: "click to browse"
        })]
      }), /*#__PURE__*/_jsxs(HelperText, {
        children: ["Supported formats: ", formattedAcceptFileExtension, " (Max 10MB)"]
      })]
    }), /*#__PURE__*/_jsx("input", {
      ref: inputRef,
      type: "file",
      style: {
        display: 'none'
      },
      multiple: multiple,
      accept: accept === null || accept === void 0 ? void 0 : accept.join(','),
      onChange: handleChange
    })]
  });
};